import { FC, useMemo } from 'react';
import { EasTable } from 'ui/EasTable';
import { returnItemTableStructure } from './tableStructure';
import { ReturnItemTableProps, TReturnItemTableRow } from './types';

export const ReturnItemTable: FC<ReturnItemTableProps> = ({ items, loading, currency }) => {
	const itemsWithCurrency: TReturnItemTableRow[] = useMemo(
		() =>
			items.map((item) => ({
				...item,
				id: item.return_id,
				payment_currency_code: currency,
			})),
		[items, currency],
	);

	const handleAction = () => {};

	return (
		<EasTable<TReturnItemTableRow>
			tableStructure={returnItemTableStructure}
			items={itemsWithCurrency}
			itemsIsLoading={loading}
			handleAction={handleAction}
		/>
	);
};
